<template>
  <div class="main-wrapper">
    <router-view v-slot='{ Component }'>
      <div class="row">
        <component :is='Component'/>
      </div>
    </router-view>
  </div>
</template>

<script>
export default {
  name: "AuthLayout"
}
</script>

<style scoped>

</style>
